<template>
	<UiElement class="position-sticky top-0 start-0 d-flex justify-content-between align-items-center z-3" :settings="page.appearance.body.settings">
		<div class="position-relative" :class="{ 'opacity-0': hideBtn1 }">
			<div
				v-if="hideBtn1"
				class="position-absolute w-100 h-100 z-1"
			/>

			<router-link :to="makePath('/cancel-order')" class="text-decoration-none">
				<UiButton :settings="headerButton1 || headerButton1SettingsFallback" :content="translations?.cancel || '{cancel}'">
				</UiButton>
			</router-link>
		</div>

		<UiElement :settings="logo || logoSettingsFallback">
			<img
				v-if="general?.elements?.logo?.settings?.image"
				:src="general.elements.logo.settings.image"
				class="w-100 h-100"
				alt=""
			/>

			<img
				v-else
				src="/images/logo_fallbach.png"
				class="w-100 h-100"
				alt=""
			/>
		</UiElement>

		<div></div>

		<div class="position-relative" :class="{ 'opacity-0': hideBtn2 }">
			<div
				v-if="hideBtn2"
				class="position-absolute w-100 h-100 z-1"
			/>

			<UiButtonLanguage :settings="headerButton2 || headerButton2SettingsFallback" />
		</div>
	</UiElement>
</template>
<script setup>
	import { defineProps, computed } from 'vue';
	import { storeToRefs } from 'pinia';
	import { useKioskRoute } from '@/composables/useKioskRoute';
	import { useInheritedSettings } from '@/composables/useInheritedSettings';
	import { useThemeStore } from '@/stores/useThemeStore';
	import { useTranslationsStore } from '@/stores/useTranslationsStore';
	import UiElement from '@/components/UI/UiElement.vue';
	import UiButton from '@/components/UI/UiButton.vue';
	import UiButtonLanguage from '@/components/UI/UiButtonLanguage.vue';

	const themeStore = useThemeStore();
	const translationsStore = useTranslationsStore();

	const { makePath } = useKioskRoute();

	const { translations } = storeToRefs(translationsStore);
	const { theme } = storeToRefs(themeStore);

	defineProps({
		logo: {
			type: Object,
			default: null
		},
		headerButton1: {
			type: Object,
			default: null
		},
		headerButton2: {
			type: Object,
			default: null
		},
		hideBtn1: {
			type: Boolean,
			default: false
		},
		hideBtn2: {
			type: Boolean,
			default: false
		}
	});

	const page = computed(() => theme.value.pages.header);
	const general = computed(() => theme.value.general);
	const elements = computed(() => page.value.elements);
	const headerButton1SettingsFallback = useInheritedSettings(computed(() => elements.value?.headerButton1));
	const headerButton2SettingsFallback = useInheritedSettings(computed(() => elements.value?.headerButton2));
	const logoSettingsFallback = useInheritedSettings(computed(() => elements.value?.logo));
</script>